import { forwardRef, type InputHTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

export const inputVariants = cva(
  // Base
  'block w-full rounded-lg border bg-ink-50 text-ink-900 placeholder:text-ink-400 ' +
    'transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 ' +
    'disabled:cursor-not-allowed disabled:opacity-60',
  {
    variants: {
      variant: {
        default:
          'border-ink-200 hover:border-ink-300 focus-visible:ring-accent-500/40 focus-visible:border-accent-500',
        error:
          'border-danger-500 focus-visible:ring-danger-500/40 focus-visible:border-danger-500',
      },
      size: {
        sm: 'h-8 px-2.5 text-sm',
        md: 'h-10 px-3 text-sm',
        lg: 'h-12 px-4 text-base',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  }
);

export interface InputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'>,
    VariantProps<typeof inputVariants> {}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, variant, size, type = 'text', ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        className={cn(inputVariants({ variant, size }), className)}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';
